<template>
  <!-- 모바일 채팅 메세지 -->
  <div> 
    <div class="user-nametag" :class="{mine:isMine}">
      <div class="user" :class="{same:isSame,user_list:userList}">
        
        <div class="profileImg" >
         
          <div class="img" v-if="userinfo.profile_photo_path"
           :style="{backgroundImage:`url(${userinfo.profile_photo_url})`}"
          >
            <div v-if="isOwner" class="mark"><img src="@/assets/imgs/chat/owner.gif"></div>
            <div v-if="isManager" class="mark"><img src="@/assets/imgs/chat/manager.gif"></div>
          </div>
          <div class="img" v-else
             :style="{backgroundImage:`url(${require('@/assets/imgs/profile_blank.jpg')})`}"
          >
            <div v-if="isOwner" class="mark"><img src="@/assets/imgs/chat/owner.gif"></div>
            <div v-if="isManager" class="mark"><img src="@/assets/imgs/chat/manager.gif"></div>
          </div>
        </div>       
        <div class="userName" :style="lineheightstye" >
          <span class="nick" @click="viewMenu()" :class="{isMe:userinfo.id === currentUserId}">                  
            <span v-if="userinfo.level >=0 " class="level_icon">                   
              <template v-if="userinfo.role==='user'">                      
                <img :src="`${require('@/assets/imgs/level/'+userinfo.level+'.png')}`">                      
              </template>
              <template v-if="userinfo.role==='admin' || userinfo.role==='manager'">
                <img :src="`${require('@/assets/imgs/level/m.png')}`"> 
              </template>                    
            </span> {{userinfo.nic?userinfo.nic:userinfo.from}}  <span class="mark_me" v-if="userinfo.id === currentUserId && currentUserId !==0">나</span>
          </span>
          <div v-if="msg" class="msg">
            <span class="msgbox">{{msg}}</span>
          </div>
        </div>     

       
      </div>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
import { auth } from '@/components/mixins/auth.js';
export default { 
  mixins:[auth],   
  props:{
    userinfo:{      },
    displaymytalk:{      },
    displayProfileImage:{      },
    lineheight:{      },
    msg:{},
    roominfo:{},
    owner:{},
    manager:{},
    managerInfo:{},
    isSame:{default:false},
    isMine:{default:false},
    userList:{default:false}, //유저목록용이면 true,     
    
  },
  data(){
    return{           
      senduser:'',
      lineheightstye:{},
      view_userInfo:false,
      socket: io(this.$store.state.serverDomain + ":3000"),
    }
  },
  components:{      

  },
  mounted(){
      // Listen to all clicks on the document
      // document.addEventListener("click", function(event)
      // {
      //     // 해당 클래스 네임을 클릭시는 팝업을 띄움
      //     if( event.target.classList !='nick' &&
      //     ( event.target.closest(".messages-container") || event.target.closest(".aside") )
      //     )//messages-container 부모영역일때만 클릭시 하이드
      //     {
      //         this.ContextMenu = false;
      //     }
      // }.bind(this));
      if(this.lineheight){
          this.lineheightstye ={
              lineHeight: 130 +'%',
              paddingLeft:0
          }
      }
  },
  computed:{
    isOwner(){
      if(this.roominfo && this.roominfo.user_id === this.userinfo.id)           
      {
        return true;
      }else{
        return false;
      }
    },
    isManager(){
      if(this.roominfo && this.roominfo.manager.find((manager)=>manager.user_id === this.userinfo.id))
      {
        return true;
      }else{
        return false;
      }
    },
    isForceOut()
    {
      if(this.roominfo && this.roominfo.ban.find((ban)=>ban.user_id === this.userinfo.id))
      {
          return true;
      }else{
          return false;
      }
    },
    currentUserId(){
      return this.$store.getters.currentUser.id;
    },
    switchManager() {
        if (this.isManager) {
            return "매니저 제외";
        } else {
            return "매니저 등록";
        }
    },
    switchForceOut() {
      if (this.isForceOut) {
          return "강퇴 해제";
      } else {
          return "강퇴처리";
      }
    },
  },
  methods:{
    viewMenu(){
        // if(this.userinfo.id ==0)
        // {
        //   alert('비회원입니다.');
        //   return;
        // }              
        // this.view_userInfo = !this.view_userInfo;  
      let data = {
        userinfo:this.userinfo,
        isOwner:this.isOwner,
        isManager:this.isManager,
        owner:this.owner,
        manager:this.manager,
        show:true,
        roominfo:this.roominfo
      }
      this.$emit('view-user-info', data);      
        
    },
    hideContextMenu(){
      setTimeout(()=> {
        this.ContextMenu = false;
      }, 3000);
    },
    requestmtm()
    {
        this.Mtm = true;
    },
    confirm() {
        this.Mtm = false;
    },
    
      
  }
};
</script>

<style lang="scss" scoped>

    .isMe{
  font-weight:bold;
}
.mark_me{
  display: inline-block;
  background: #444444;
  color:white;
  padding:2px;
  border-radius: 5px;
  font-weight: normal;
  font-size:11px;
}

.mine{
    .profileImg {display: none;} 
    .nick{display: none;}  
    .user {
        flex-direction:row-reverse;
    }  
    .msg:before{
      display: none !important;
    }  
    .msg:after{  
        content: "";
        display: inline-block;
        width: 0;
        height: 0;           
        top:10px;  
        right:-10px; 
        border-left: 10px solid #0787ff;
        border-bottom: 10px solid transparent;        
        position:absolute;
    }
    .msg{
        margin-right:10px;
        position: relative;
        width: 100%;
        .msgbox{            
            color:#fff !important;
            font-weight:normal;
            background:#0787ff  !important;  
            float:right;  
            letter-spacing: normal;       
        }
       
    }    
}
.user-nametag {
    line-height: 50px;
    
    //단순 유저 정보 표기용
    .user_list{
      .profileImg {
        height:30px !important;
        .img{
          width: 30px !important; 
          height: 30px !important; 
          }
        .mark{
          padding-top: 2px !important;
        }
      }
      .userName {
        display: flex;
        align-items: center;
        .nick{        
          .level_icon{
            img{
              vertical-align: middle;
              width:24px !important;
            }
          }
        }
      }        
    }

    .same{
        .profileImg {height:0 !important;.img{display: none;}} 
        .nick{display: none;}  
        .msg:before{
            border:none !important;    
        } 
        .msg:after{
            border:none !important;    
        } 
    }
    .user {
      display: flex;
    .profileImg {
      width: 40px;
      height: 40px;
      margin: 0 5px 0 10px;
      .img {
        background-color: #000;
        width: 40px;
        height: 40px;
        background-size:cover;
        border-radius: 999px;
      }

      .mark{
        padding-top: 10px;
      }

    }
    
    .userName {      
      font-size: 12px;
      
      padding-left: 20px;
      width: calc(100vw - 110px);       
      .nick{        
        .level_icon{
         img{
           vertical-align: middle;
           width:20px;
         }
        }
      }
    }
    .msg:before{
        content: "";
        display: inline-block;
        width: 0;
        height: 0;     
        position:absolute; 
        top:20%;
        left:-10px;                 
        border-bottom: 10px solid transparent;        
        border-right: 10px solid #ffffff;
    }
    .msg{
        margin-left:10px;
        position: relative;
        width: 100%;
        .msgbox{    
            display: inline-block;        
            padding: 10px;
            color:#545454;
            font-weight:normal;
            background:#ffffff;
            border-radius: 10px;
            max-width: 80%;
        }
       
    }
    .myTalk {
      font-size: 11px;
      color: #3e3e3e;
      padding-right: 10px;
    }
  }
}

</style>
